module.exports = __webpack_public_path__ + "static/img/icon_szh_zhptyy_gc_zxgz.31008425.png";